module.exports = __webpack_public_path__ + "img/certificate-1.f023d079.png";